import Application      from "./Application";
import AudioManager     from "./AudioManager";
import PreloaderScene   from "./PreloaderScene";
import Common           from "./Common";

export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {
        Common.assets = new P3.AssetManager();
        Common.audio = P3.Button.audio = new AudioManager();
        Common.language = language;

        const isPortrait = false;

        const params = {};
        params.holderId = "game";
        params.width = this._width;
        params.height = this._height;
        params.portrait = isPortrait;
        params.aspectRatioFillHeight = !isPortrait;
        params.rotateImageUrl = "./assets/images/rotate_screen" + ".jpg";
        params.rotateImageColor = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        const view = new P3.View(params);
        view.signals.ready.addOnce(function (canvas) {

            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1.0;

            const stage = new PIXI.Container();
            Common.stage = stage;

            //const input = new Input();
            //input.init(stage, canvas);
            //Common.input = input;

            //on clicking the document focus on canvas, fix for buttons not working on mobile
            document.onclick = () => {
                canvas.focus();
            };

            const renderer = PIXI.autoDetectRenderer(this._width, this._height, options);
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new P3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            // let count = 0;

            PIXI.ticker.shared.add(function (deltaTime) {
                //   count++;
                window.P3.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                // if(count % 2 === 0){
                scene.update();
                //   }

                renderer.render(Common.stage);
            }, this);

            /*
             const timestep = new p3.Timestep(p3.Timestep.FIXED);
             timestep.init(this.update, this.render, this);
             Common.timestep = timestep;
             */

            window.delay = function (callback, delay, scope) {
                TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            {name: "preloader", url: "images/" + "preloader" + ".json"}
        ];
        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function () {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();

            Common.audio.addSounds(sounds, [".mp3", ".ogg"], "");
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {

        const files = [
            {name: "enemy", url: "images/" + "enemy" + ".png"},
            {name: "barrel", url: "images/" + "barrel" + ".png"},
            {name: "barrel_test", url: "images/" + "barrel_test" + ".png"},
            {name: "floor", url: "images/" + "floor" + ".png"},
            {name: "gradient", url: "images/" + "gradient" + ".png"},
            {name: "magic_ball", url: "images/" + "magic_ball" + ".png"},
            {name: "plant_l", url: "images/" + "plant_l" + ".png"},
            {name: "plant_s", url: "images/" + "plant_s" + ".png"},
            {name: "small_plant", url: "images/" + "small_plant" + ".png"},
            {name: "test", url: "images/" + "test" + ".png"},
            {name: "texture", url: "images/" + "texture" + ".png"},
            {name: "wall", url: "images/" + "wall" + ".png"},
            {name: "potion", url: "images/" + "potion" + ".png"},
            {name: "stone", url: "images/" + "stone" + ".png"},
            {name: "wood", url: "images/" + "wood" + ".png"},
            {name: "arrow", url: "images/" + "arrow" + ".png"},

            {name: "fence", url: "images/" + "fence" + ".png"},
            {name: "house_door", url: "images/" + "house_door" + ".png"},
            {name: "house_wall", url: "images/" + "house_wall" + ".png"}

            //fonts
            //{name: "calibri_bold", url: "fonts/" + "calibri_bold" + ".xml"},
            //jpeg
            //{name: "bg_ui", url: "images/" + "bg_ui" + ".jpg"},
            //sheets
            //data
            //{name: "copy", url: "data/" + "copy" + ".json"},
            //particles
            //{name: "particles_fx", url: "particles/" + "particles_fx" + ".json"},
            //spine
            //{name: "loading", url: "images/" + "loading" + ".json"}
        ];

        const sounds = [];
        if (files.length) {
            this._preloader = new PreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();

            Common.audio.addSounds(sounds, [".m4a", ".mp3", ".ogg"], "assets/audio/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;

        const config = {};
        Common.config = config;
    }

    startGame() {
        delay(function () {
            this._game = new Application();
            this._game.init();
        }, 1.0, this);
    }

    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();
        Common.finishedLoading = true;
        this._preloader.loaded = 1;
        this.startGame();
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(P3.View.width, P3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}

window.Main = Main;

/**
 *
 * @param texture
 * @param holder
 * @returns {*}
 */
function createSprite(texture, holder) {
    let sprite;
    if (typeof texture === "string") {
        sprite = new PIXI.Sprite(Common.assets.texture(texture));
    } else if (texture instanceof PIXI.Texture) {
        sprite = new PIXI.Sprite(texture);
    } else {
        console.warn("texture neither a string nor a PIXI.Texture, falling back to empty texture");
        sprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
    }
    if (holder) holder.addChild(sprite);
    return sprite;
}
P3.createSprite = createSprite;

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */
function createText(copy, fontName, size, holder, colour) {
    const col = colour | 0x000000;
    const textView = new PIXI.Text(copy, {fontFamily: fontName, fontSize: size, fill: col});
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    return textView;
}
P3.simpleText = createText;

/**
 * Creates the texture for the popups sprite
 * @param width
 * @param height
 * @returns {Texture|PIXI.Texture}
 */
function createPopUpTexture(width, height) {
    let g = new PIXI.Graphics();
    g.beginFill(0xffffff);
    g.lineStyle(25, 0xe1e1e1);
    g.drawRoundedRect(0, 0, width, height, 10);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    g.destroy();
    return texture;
}

/**
 * Creates a popup screen sprite
 * @param width {number}
 * @param height {number}
 * @param centre {boolean}
 * @param holder {PIXI.Container}
 * @returns {PIXI.Sprite}
 */
function createPopup(width, height, centre, holder) {
    let sc = new PIXI.Sprite(createPopUpTexture(width, height));
    sc.anchor.set(0.5);
    if (centre) sc.y = P3.View.height * 0.5;
    if (holder) holder.addChild(sc);
    sc.genTex = true;
    return sc;
}
P3.createPopup = createPopup;

/**
 * Depths sorts children in container passed to it by x, y coordinates
 * @param container {PIXI.Container}
 */
function depthSortXY(container) {
    container.children.sort(function (a, b) {
        return a.position.y > b.position.y ? 1 : a.position.y < b.position.y ? -1 : a.position.x > b.position.x ? 1 : a.position.x < b.position.x ? -1 : 0
    });
}
P3.depthSortXY = depthSortXY;

/**
 * Depth sorts children by z value (must assign a z value to the display object for this to work)
 * @param container
 * @param highToLow {?boolean}
 */
function depthSortZ(container, highToLow) {
    highToLow = highToLow || true;
    const array = container.children;
    const len = array.length - 1;
    quickSort(0, len);

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i].z < pivot.z) swap(index++, i);
                else if (highToLow && array[i].z > pivot.z) swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
}
P3.depthSortZ = depthSortZ;

/*
 function(a, b) {
 return (a.position.x * nx + a.position.y * ny) - (b.position.x * nx + b.position.y * ny);
 }
 function(a, b) {
 return (a.position.x + a.position.y) - (b.position.x + b.position.y);
 }
 */
